import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";

const PricingCard = ({
  badgeLabel,
  badgeColorClass,   // badge-dark | badge-orange | badge-purple
  btnClass,          // btn-trial | btn-starter | btn-pro
  highlight,         // true → Pro：加邊框 + 「最受歡迎」
  popularText,
  monthlyPrice,
  annualPrice,       // 體驗方案為 null（無年費）
  subtitle,
  priceId,
  buttonText,
  features,
}) => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("PricingCard", "home/home_PricingCard_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.PricingCard || { Main: {} };

  const signinUrl = process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in";
  const finalUrl = `${signinUrl}&price=${priceId}`;

  // 體驗方案（無年費）顯示「/ 30 天」，付費方案顯示「/ 月繳」
  const priceUnit = annualPrice != null ? LANGUAGE.Main.PerMonth : LANGUAGE.Main.Per30Days;

  return (
    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
      <div className={`ai-pricing-card${highlight ? ' is-popular' : ''}`}>
        {highlight && popularText && <span className="ai-popular-ribbon">🔥 {popularText}</span>}

        <span className={`ai-plan-badge ${badgeColorClass}`}>{badgeLabel}</span>

        <div className="ai-plan-price">
          <span className="cur">US$</span>
          <span className="amt">{monthlyPrice}</span>
          <span className="per">{priceUnit}</span>
        </div>
        <p className="ai-plan-sub">{subtitle}</p>

        <ul className="ai-plan-features">
          {features.map((item, idx) => (
            <li key={idx}>
              <span className="feat-check">✓</span>
              <span className="feat-name">{item.text}</span>
              <span className="feat-val">
                {item.text_num_f ? item.text_num_f + ' ' : ''}{item.num}{item.text_num_b ? ' ' + item.text_num_b : ''}
              </span>
            </li>
          ))}
        </ul>

        <a className={`ai-plan-btn ${btnClass}`} href={finalUrl}>{buttonText}</a>
      </div>
    </div>
  );
};

export default PricingCard;
